import { shuffleDeck } from "./cardUtils";
import deck from "./deck";

// Shuffles the shared 52-card deck and returns the first `count` cards.
// Card objects are shared references from deck.js - never mutate them,
// only read suit/details off of them.
const drawRandomCards = (count = 24) => {
  return shuffleDeck(deck).slice(0, count);
};

// Setback game-count scoring (Ace=4, King=3, Queen=2, Jack=1, Ten=10,
// everything else 0) is already encoded as `gamePoints` on each card in
// deck.js, so this just sums it rather than duplicating the scoring map.
const calculateGameCount = (cards) => {
  return cards.reduce((total, card) => total + (card.details?.gamePoints || 0), 0);
};

export { drawRandomCards, calculateGameCount };
